import type { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Login from '../pages/authentication/Login';
import { userHasRole } from 'src/utils/userHelpers';

interface RoleGuardProps {
  allowedRoles: string[];
  children: ReactNode;
}

const RoleGuard: FC<React.PropsWithChildren<RoleGuardProps>> = (props) => {
  const { allowedRoles, children } = props;
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isAuthenticated) {
    return <Login />;
  }

  if (!userHasRole(allowedRoles)) {
    return <Navigate to="/401" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RoleGuard;